import EquipmentDocuments from "../document/EquipmentDocuments";
import {
  Button,
  Col,
  Descriptions,
  Dropdown,
  Popconfirm,
  Row,
  Skeleton,
  Space,
  Tabs,
  Tag,
} from "antd";
import axiosInstance, { api } from "../common/api";
import {
  Await,
  useNavigate,
  useParams,
  useRevalidator,
  useRouteLoaderData,
  useSearchParams,
} from "react-router";
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  MoreOutlined,
  QrcodeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { date2locale, downloadFile } from "../common/common";
import Inspections from "../inspection/Inspections";
import TablePage from "../components/TablePage";

const assignmentColumns = [
  { title: "ID", dataIndex: "id", key: "id", width: 70 },
  { title: "Dipendente", dataIndex: ["employee", "fullName"], key: "employee", ellipsis: true },
  {
    title: "Data assegnazione",
    dataIndex: "startDate",
    key: "startDate",
    render: (date) => date && date2locale(date),
  },
  {
    title: "Data restituzione",
    dataIndex: "endDate",
    key: "endDate",
    render: (date) => (date ? date2locale(date) : "—"),
  },
  {
    title: "Stato",
    key: "status",
    render: (record) => (
      <Tag color={record.endDate ? "default" : "green"}>
        {record.endDate ? "Restituito" : "Assegnato"}
      </Tag>
    ),
  },
  { title: "Note", dataIndex: "notes", key: "notes", ellipsis: true },
];

export default function () {
  const navigate = useNavigate();
  const data = useRouteLoaderData("equipment");
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const revalidator = useRevalidator();
  const fetch = () => revalidator.revalidate();

  const items = [
    {
      key: "serialNumber",
      label: "Matricola",
      children: data.serialCode,
    },
    {
      key: "type",
      label: "Categoria",
      children: data.type?.name,
    },
    {
      key: "description",
      label: "Descrizione",
      children: data.description,
    },
    {
      key: "firstInspectionDate",
      label: "Data ultima ispezione o acquisto",
      children: data.firstInspectionDate && date2locale(data.firstInspectionDate),
    },
    {
      key: "notes",
      label: "Note",
      children: data.notes,
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli attrezzatura"
        secondary={`ID: ${id} • ${!!data.assignment ? "Assegnato" : "Disponibile"}`}
        extra={
          <Space size={4}>
            {!data.assignment && (
              <Button type="primary" icon={<UserOutlined />} onClick={() => navigate("assign")}>
                Assegna
              </Button>
            )}
            <Button icon={<QrcodeOutlined/>} onClick={() => downloadFile(`equipment/${id}/label`)}>
              Genera etichetta
            </Button>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deleteEquipment",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => axiosInstance.delete(`equipment/${id}`).then(fetch)}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="horizontal"
        styles={{ label: { width: "25%" }, content: { width: "75%" } }}
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={1}
        colon={false}
        items={items}
      />
      <Tabs
        onChange={() => {
          [...searchParams.keys()].forEach((key) => searchParams.delete(key));
          setSearchParams(searchParams);
        }}
        destroyOnHidden
        items={[
          {
            key: "assignments",
            label: "Assegnazioni",
            children: (
              <TablePage
                key={`${id}-${data.assignment?.id ?? "available"}`}
                columns={assignmentColumns}
                addPath="assign"
                showAdd={!data.assignment}
                enableSelection={false}
                fetchFunction={({ page, pageSize }) =>
                  api.equipmentAssignment.list({ equipment: id, page, pageSize })
                }
              />
            ),
          },
          !!data.type.inspectionMonths && {
            key: "inspections",
            label: "Revisioni",
            children: <Inspections key={id} showTitle={false} type="EQUIPMENT" id={id} />,
          },
          {
            key: "documents",
            label: "Documenti",
            children: <EquipmentDocuments key={id} equipmentId={id} />,
          },
        ].filter((x) => !!x)}
      />
    </div>
  );
}
